import styles from "./result.module.css";

const Row = ({ label, value, highlight, color }) => {
  return (
    <div className={styles.row}>
      <span className={styles.rowLabel}>{label}</span>
      <span
        className={highlight ? styles.rowValueHighlight : styles.rowValue}
        style={color ? { color } : undefined}
      >
        {value}
      </span>
    </div>
  );
};
export default Row;
